<div class="example" *ngIf="loadingService.loading$ | async">
  <nz-spin nzSimple></nz-spin>
</div>
